@if(showPage()){
<div id="installed-patches" class="installed-container">

    @if(steps.length > 0) {
    <app-wizard [index]="stepIndex" [steps]="steps"></app-wizard>
    }

    <div id="otsc-prod-installed-main" class="ot-panel">
        <ng-scrollbar>
            <div class="ot-panel__header">
                @if(!isAgentOnline) {
                <div id="product-installed-agent-offline-error" class="ot-message ot-message--is-error">
                    <div class="ot-message__banner">
                        @if(isPrimarySystemSupported) {
                        <p class="ot-message__item" i18n>The agent on the primary system is offline.</p>
                        } @else {
                        <p class="ot-message__item" i18n>All agents are currently offline.</p>
                        }
                    </div>
                </div>
                }

                @if(isAgentOnline && isQuickAnalysisRequired && !taskInProgress) {
                <div id="product-installed-agent-analysis-error" class="ot-message ot-message--is-error">
                    <div class="ot-message__banner">
                        <p class="ot-message__item" i18n>
                            An analysis of the primary system must be completed before continuing.&nbsp;<a
                                (click)="analyzeMasterSystemClicked()">Analyze primary system</a>
                        </p>
                    </div>
                </div>
                }

                @if(isAgentOnline && !isQuickAnalysisRequired && !isPrimarySystemSupported) {
                <div id="product-installed-agent-selection-error" class="ot-message ot-message--is-error">
                    <div class="ot-message__banner">
                        <p class="ot-message__item" i18n>
                            An issue with primary system selection has been detected.&nbsp;<a
                                [routerLink]="['/products/componentdetails/' + productId + '/' + setupId]">Resolve the
                                issue</a>
                        </p>
                    </div>
                </div>
                }

                @if(requestFailed) {
                <div id="failed-request-msg" class="ot-message ot-message--is-error w-100">
                    <div class="ot-message__banner">
                        <p class="ot-message__item">
                            {{requestErrorMessage}}
                        </p>
                    </div>
                </div>
                }

                @if(isSendingPatchRemoval) {
                <div id="sending-removal-request-msg" class="ot-message ot-message--is-progress w-100">
                    <div class="ot-message__banner">
                        <p class="ot-message__item" i18n>
                            Sending patch removal request, please wait...
                        </p>
                    </div>
                </div>
                }

                @if(taskInProgress) {
                <div id="active-task-msg" class="ot-message ot-message--is-progress w-100">
                    <div class="ot-message__banner">
                        <p class="ot-message__item" i18n>
                            An activity is currently running, this page will be temporarily disabled until the activity
                            is
                            complete.&nbsp;<a (click)="goToActivitiesOverview()">View details</a>
                        </p>
                    </div>
                </div>
                }
            </div>

            @if(state == ProductInstalledState.SELECT){
            <div id="product-installed-view-select">
                @if((activeUpdate && !isQuickAnalysisRequired) || activeComponent){
                <div class="ot-panel__body ot-pl-0 ot-pr-0 ot-pb-0 updates-content-area">
                    <div class="ot-row ot-pl-1 ot-pr-1" style="width: unset;">
                        <div class="ot-row__column">
                            <small class="ot--has-text-muted" i18n>Version</small>
                            <p id="product-updates-version">{{summaryVersion}}</p>
                        </div>
                        <div class="ot-row__column">
                            <small class="ot--has-text-muted" i18n>Status</small>
                            @switch(summaryStatus) {
                            @case ('ERROR'){
                            <div id="product-installed-status-download-error"
                                class="ot-message ot-message--is-error otsc-message--is-light">
                                <div class="ot-message__banner">
                                    <p class="ot-message__item" i18n>
                                        Error downloading the item
                                    </p>
                                </div>
                            </div>
                            }
                            @case ('COMPLETE'){
                            <div id="product-installed-status-download-complete"
                                class="ot-message ot-message--is-success otsc-message--is-light">
                                <div class="ot-message__banner">
                                    <p class="ot-message__item" i18n>
                                        Downloaded
                                    </p>
                                </div>
                            </div>
                            }
                            @case ('AVAILABLE'){
                            <div id="product-installed-status-download-available"
                                class="ot-message ot-message--is-info otsc-message--is-light">
                                <div class="ot-message__banner">
                                    <p class="ot-message__item" i18n>
                                        Available for download
                                    </p>
                                </div>
                            </div>
                            }
                            @case ('INSTALLED'){
                            <div id="product-installed-status-download-installed"
                                class="ot-message ot-message--is-success otsc-message--is-light">
                                <div class="ot-message__banner">
                                    <p class="ot-message__item" i18n>
                                        Installed
                                    </p>
                                </div>
                            </div>
                            }
                            @case ('DEPRECATED'){
                            <div id="product-installed-status-download-deprecated"
                                class="ot-message ot-message--is-success otsc-message--is-light">
                                <div class="ot-message__banner">
                                    <p class="ot-message__item" i18n>
                                        Deprecated
                                    </p>
                                </div>
                            </div>
                            }
                            @default {
                            <div id="product-installed-status-download-progress"
                                class="ot-message ot-message--is-info otsc-message--is-light">
                                <div class="ot-message__banner">
                                    <p class="ot-message__item" i18n>
                                        Downloading...
                                    </p>
                                </div>
                            </div>
                            }
                            }
                        </div>
                        <div class="ot-row__column">
                            <small class="ot--has-text-muted" i18n>Description</small>
                            @if(summaryDescription){
                            <p id="product-installed-description">{{summaryDescription}}</p>
                            } @else {
                            <ng-container *ngTemplateOutlet="naTemplate"></ng-container>
                            }
                        </div>
                        <div class="ot-row__column">
                            <small class="ot--has-text-muted" i18n>Size</small>
                            @if(summaryDescription){
                            <p id="product-installed-size">{{summarySize}}</p>
                            } @else {
                            <ng-container *ngTemplateOutlet="naTemplate"></ng-container>
                            }
                        </div>
                        <div class="ot-row__column">
                            <small class="ot--has-text-muted" i18n>Zero Downtime</small>
                            @if(summaryZeroDowntime2) {
                            <p id="product-installed-zero-downtime" i18n>Supported</p>
                            } @else {
                            <ng-container *ngTemplateOutlet="naTemplate"></ng-container>
                            }
                        </div>
                        <div class="ot-row__column">
                            <small class="ot--has-text-muted" i18n>Release date</small>
                            <p id="product-installed-release-date">{{summaryReleaseDate | date:'EEEE, LLLL d, yyyy'}}
                            </p>
                        </div>
                    </div>
                </div>
                <div id="product-installed-tab-area">
                    <app-tabs [identifier]="'product-installed-tabs'" (selected)="onSelectedTabChange($event)"
                        [tabs]="installedTabs" [color]="TabColor.SECONDARY" [selectedIndex]="activeTab"
                        [selectOnInit]="false"></app-tabs>
                    @if(activeTab == Tabs.PATCHES){
                    <app-datatable [identifier]="'product-installed-hotfix-table'" [scroll]="false"
                        [overrideSelectAll]="overrideHotfixSelectAll" (selectAllClickEvent)="selectAllHotfix($event)"
                        [recountSelectedRow]="recountSelectedRow" (checkboxchangeevent)="selectSingleHotfix($event)"
                        [title]="''" [showcheckboxes]="!taskInProgress" [cols]="productInstalledTableCols"
                        [rows]="productInstalledTableRows" [isloading]="patchesLoading"
                        (actionmenuevent)="actionMenuClicked($event)"
                        (rowclickevent)="rowClick($event)"></app-datatable>
                    }
                </div>
                }
            </div>
            } <!--end of select-->

            @if(state == ProductInstalledState.DOWNLOAD){
            <div class="ot-row">
                <p class="ot-wizard-msg-text ot-pt-1 ot-pl-1" i18n>To remove the requested patches, the following
                    missing packages
                    must be downloaded to replace removed files.</p>
            </div>
            <div class="ot-row">
                <div class="ot-ml-1 ot-mb-1">
                    @if(needsDownload && isOnlineMode){
                    <button id="download-missing-packages" role="button" otsc-button [disabled]="isDownloading"
                        color="primary" (click)="download()" i18n>Download
                        {{this.missingPackageRows.length}} item(s)</button>
                    }
                    @if(needsDownload && !isOnlineMode){
                    <button id="upload-missing-packages" role="button" otsc-button [disabled]="isDownloading"
                        color="primary" (click)="openOfflineUpload()" i18n>Upload
                        {{this.missingPackageRows.length}} item(s)</button>
                    }
                </div>
            </div>

            @if(isLoadingMissing || (isValidatingPackages && !isError)){
            <div id="missing-packages-validating" class="ot-message ot-message--is-progress w-100">
                <div class="ot-message__banner">
                    <p class="ot-message__item" i18n>
                        Validating packages...
                    </p>
                </div>
            </div>
            }

            @if(!isValidatingPackages && isValidatingPackagesComplete && getDownloadCount() == 0 && !isError) {
            <div id="missing-packages-validation-success" class="ot-message ot-message--is-success w-100">
                <div class="ot-message__banner">
                    @if(!needsDownload && isOnlineMode) {
                    <p class="ot-message__item" i18n>All of the required packages have
                        been downloaded.</p>
                    }
                    @if(!needsDownload && !isOnlineMode) {
                    <p class="ot-message__item" i18n>All of the required packages have
                        been uploaded.</p>
                    }
                </div>
            </div>
            }

            @if(!isValidatingPackages && isValidatingPackagesComplete && getDownloadCount() > 0 && !isError){
            <div id="missing-packages-validation-warning" class="ot-message ot-message--is-warning w-100">
                <div class="ot-message__banner">
                    @if(needsDownload && getDownloadCount() == 1 && isOnline){
                    <p class="ot-message__item" i18n>The
                        following package must be downloaded
                        before the system can be updated.</p>
                    } @else if (needsDownload && getDownloadCount() > 1 && isOnline) {
                    <p class="ot-message__item" i18n>The
                        following packages must be downloaded
                        before the system can be updated.</p>
                    } @else if (needsDownload && getDownloadCount() == 1 && !isOnline) {
                    <p class="ot-message__item" i18n>The
                        following package must be uploaded
                        before the system can be updated.</p>
                    } @else if (needsDownload && getDownloadCount() > 1 && !isOnline) {
                    <p class="ot-message__item" i18n>The
                        following packages must be uploaded
                        before the system can be updated.</p>
                    }
                </div>
            </div>
            }

            @if(isError){
            <div id="missing-packages-validation-error" class="ot-message ot-message--is-error w-100">
                <div class="ot-message__banner">
                    <p class="ot-message__item">
                        {{errorMessage}}
                    </p>
                </div>
            </div>
            }
            <app-datatable [identifier]="'missing-packages-table'" [cols]="missingPackageCols"
                [rows]="missingPackageRows" [scroll]="false" [sortdata]="false"
                (actionmenuevent)="downloadActionMenuClicked($event)" [isloading]="isLoadingMissing"></app-datatable>
            }<!--end of download-->

            @if(state == ProductInstalledState.REVIEW || state == ProductInstalledState.REMOVE){
            @if(state == ProductInstalledState.REVIEW) {
            <div class="ot-row ot-mb-0">
                <div class="ot-row__column">
                    <div role="group" class="ot-btn-group ot-mb-0">
                        <div class="ot-dropdown" [ngClass]="{'ot-dropdown--is-active': isExportBtnClicked}">
                            <button role="button" i18n-title title="Export metadata" (click)="toggleExportMenu()"
                                class="ot-btn ot-btn--is-secondary" [disabled]="isWaitingForUpgradePrompts" i18n>
                                Export metadata
                            </button>
                            <ul class="ot-dropdown__menu">
                                <li class="ot-dropdown__item" (click)="showExportConfirmation('csv')" i18n>
                                    CSV (comma-separated values) file
                                </li>
                                <li class="ot-dropdown__divider">
                                </li>
                                <li class="ot-dropdown__item" (click)="showExportConfirmation('html')" i18n>
                                    Web page
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ot-row">
                <div class="ot-pl-1 ot-pr-1 ot-pb-1">
                    <p class="ot-mb-0" style="font-size: 16px;" i18n>
                        The following list may contain patches to be removed, files to be replaced from the quarterly
                        update, language packs and patches to be reapplied.
                    </p>
                </div>
            </div>
            }

            <div class="review-table-container">
                <app-datatable [identifier]="'product-installed-patches-review-table'"
                    (actionmenuevent)="actionMenuClicked($event)" [isloading]="!isRemoveItemsReady"
                    [showcheckboxes]="false" [title]="''" [cols]="removeItemsCols" [rows]="removeItemsRows"
                    [scroll]="false"></app-datatable>
            </div>
            } <!-- end of review/remove -->

            @if(state == ProductInstalledState.VALIDATE){
            <div class="ot-row">
                <p class="ot-pl-1 ot-pr-1" style="font-size: 16px;margin-bottom: 8px;" i18n>
                    Before System Center Manager removes patches from your {{activeProduct.name}} environment, it
                    verifies conditions on the
                    {{activeProduct.name}} instances to ensure that it can remove the patches successfully. If there are
                    no problems, you
                    can
                    proceed with the removal. If the Prerequisite checks dialog box displays warnings or errors, you
                    normally must
                    resolve the underlying problems before you can proceed. If a check fails, click the instance below
                    to review the
                    message. Once the problem is fixed, click Retry to try again.
                </p>
            </div>

            @if(!isValidating && isValidated && !isValidationWarning && !requestFailed && !isSendingPatchRemoval){
            <div class="ot-message ot-message--is-success w-100">
                <div class="ot-message__banner">
                    <p class="ot-message__item" i18n>
                        Prerequisite checks passed successfully.
                    </p>
                </div>
            </div>
            }

            @if(isValidating) {
            <div class="ot-message ot-message--is-progress w-100">
                <div class="ot-message__banner">
                    <p class="ot-message__item" i18n>
                        Validating request, please wait...
                    </p>
                </div>
            </div>
            }

            @if(registeredServerCheck && registeredServerCheck.additionalHosts.length > 0) {
            <div class="ot-message ot-message--is-error">
                <div class="ot-message__banner">
                    <p class="ot-message__item" i18n>
                        {registeredServerCheck.additionalHosts.length,
                        plural,
                        =1 {
                        Unclustered instance was found.
                        }
                        other {{{registeredServerCheck.missingHosts.length}} unclustered instances were found.}
                        }
                        &nbsp;<a (click)="showPreReqErrorDetails('ADDITIONAL')">View details</a>
                    </p>
                </div>
            </div>
            }

            @if(registeredServerCheck && registeredServerCheck.missingHosts.length > 0) {
            <div class="ot-message ot-message--is-error">
                <div class="ot-message__banner">
                    <p class="ot-message__item" i18n>
                        {registeredServerCheck.missingHosts.length,
                        plural,
                        =1 {
                        Unmanaged instance was found.
                        }
                        other {{{registeredServerCheck.missingHosts.length}} unmanaged instances were found.}
                        }
                        &nbsp;
                        @if(csInfo.isHostManagement){
                        <a (click)="showPreReqErrorDetails('MISSING')">Unregister systems</a>
                        } @else {
                        <a (click)="showPreReqErrorDetails('MISSING')">View details</a>
                        }
                    </p>
                </div>
            </div>
            }

            @if(signInCancelled){
            <div class="ot-message ot-message--is-error w-100">
                <div class="ot-message__banner">
                    <p class="ot-message__item" i18n>
                        You must sign in to start the process.&nbsp; <a (click)="showLoginDialog()">Sign in</a>
                    </p>
                </div>
            </div>
            }

            <div class="ot-row">
                <div class="ot-row__column">
                    <app-tabs [identifier]="'system-details-instances-tabs'" [tabs]="validateTabs"
                        [color]="TabColor.SECONDARY"></app-tabs>
                    <app-datatable [identifier]="'product-installed-validation-table'" [disableSelectAllCheckbox]="true"
                        [recountSelectedRow]="recountSelectedRow" [scroll]="false" [showcheckboxes]="true" [title]="''"
                        [overrideShowError]="true" [cols]="validationTableCols" [rows]="preReqTableRows"
                        (actionmenuevent)="validateActionMenuClicked($event)"
                        (onclickrowlink)="viewValdationDetails($event)" [showIconColumn]="true"></app-datatable>
                </div>
            </div>
            } <!-- end of validate -->
        </ng-scrollbar>
    </div>
    <div class="ot-wizard-panel-footer"
        [ngClass]="{'ot-flex--is-space-between' : stepIndex > 0 && (state != ProductInstalledState.REMOVE || (state == ProductInstalledState.REMOVE && requestFailed)), 
        'ot-wizard-panel-footer--is-right-justified' : stepIndex == 0 || state == ProductInstalledState.REMOVE && !requestFailed}">

        @if(stepIndex > 0 && (state != ProductInstalledState.REMOVE || (state == ProductInstalledState.REMOVE &&
        requestFailed))) {
        <button role="button" (click)="goToPrevState()" aria-label="Back" i18n-title title="Back"
            class="otsc-btn__back ot-mt-1 ot-mb-1 ot-btn ot-btn--is-micro ot-btn--is-icon-btn ot-ml-1">
            <div class="otsc-back_btn">
            </div>
        </button>
        }

        <div role="group" class="ot-btn-group">
            @if(showRetry && isAgentOnline){
            <button role="button" i18n-title title="Retry" class="ot-btn ot-btn--is-primary" (click)="retry()" i18n>
                Retry
            </button>
            }

            <button role="button" i18n-title title="Next" class="ot-btn ot-btn--is-primary" (click)="goToNextState()"
                [disabled]="isDisableNextBtn()">

                @if(!showNextProgressSpinner()){
                <span i18n-title title="Next" i18n>{{nextButton}}</span>
                }

                @if(showNextProgressSpinner()){
                <div class="ot-button-progress-container">
                    <div class="ot-progress ot-progress--is-spinner">
                        <div class="ot-progress__outer ot-progress__outer">
                            <div class="ot-progress__meter next-spinner"></div>
                            <div class="ot-button-progress__text" i18n-title title="Next" i18n>{{nextButton}}</div>
                        </div>
                    </div>
                </div>
                }
            </button>

            @if(state != ProductInstalledState.REMOVE || (state == ProductInstalledState.REMOVE && requestFailed)){
            <button role="button" i18n-title title="Cancel" class="ot-btn ot-btn--is-secondary"
                (click)="cancelDeploymentWizard()" i18n>
                Cancel
            </button>
            }
        </div>
    </div>
</div>
<ng-template #naTemplate>
    <p i18n>N/A</p>
</ng-template>
} @else {
<div id="product-installed-loading"
    class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
    <div class="ot-progress__outer">
        <div class="ot-progress__meter"></div>
    </div>

    @if(isLoading && !isManifestUpdating && !isAgentManifestUpdating) {
    <div class="ot-progress__text" i18n>Loading...</div>
    }

    @if(isManifestUpdating) {
    <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
    }

    @if(isAgentManifestUpdating) {
    <div class="ot-progress__text" i18n>Please wait while the Agent manifest is updated...</div>
    }
</div>
}